import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../utility';

const initialState = {
        error: null,
        contacts: [],
        contactsLoading: false,
        groups: [],
		groupsLoading: false,
		group: null,
		room: null
};

const reducer = ( state = initialState, action) => {
    switch (action.type) {
        case actionTypes.FTV_CONTACTS_SEARCH_START:
            return updateObject(state, { contactsLoading: true });
        case actionTypes.FTV_CONTACTS_SEARCH_FAIL:
            return updateObject(state, { contactsLoading: false });
        case actionTypes.FTV_CONTACTS_SEARCH_SUCCESS:
			return updateObject(state, { contactsLoading: false, contacts: action.contacts.msg.data });
		case actionTypes.FTV_GROUPS_SEARCH_START:
            return updateObject(state, { groupsLoading: true });
        case actionTypes.FTV_GROUPS_SEARCH_FAIL:
            return updateObject(state, { groupsLoading: false });
        case actionTypes.FTV_GROUPS_SEARCH_SUCCESS:
			return updateObject(state, { groupsLoading: false, groups: action.groups.msg.data });
		case actionTypes.FTV_GROUP_GET_SUCCESS:
			return updateObject(state, { groupsLoading: false, group: action.group.msg.data });
		case actionTypes.FTV_GROUP_SAVE_SUCCESS:
            return updateObject(state, { group: action.group });
		case actionTypes.FTV_CONTACTS_SET_ROOM:
            return updateObject(state, { room: action.room });
        default: 
            return state;
    }
}

export default reducer;
